import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Patients = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const jwt = localStorage.getItem('jwt');
        if (!jwt) {
            navigate('/login');
            return;
        }

        try {
            const { exp } = JSON.parse(atob(jwt.split('.')[1])); // Decode JWT payload
            if (Date.now() >= exp * 1000) {
                navigate('/login'); // Navigate if token is expired
            }
        } catch (error) {
            console.error('Invalid JWT:', error);
            navigate('/login'); // Navigate if token is invalid
        }
    }, [navigate]);

    return (
        <div>
            <h1>Patients Page</h1>
            <p>Welcome to the patients page. Access is restricted to authenticated users.</p>
        </div>
    );
};

export default Patients;
